/* Footer_object_instagram_marquee */
/*initMarquee('.Footer_object_instagram_marquee', {
    mobile: {
        duration: 50000,
        gap: 0,
        duplicated: true,
        direction: "left"
    },
    desktop: {
        duration: 80000,
        gap: 0,
        duplicated: true,
        direction: "left"
    }
});*/
/* Footer_object_instagram_marquee */

document.querySelectorAll('.Footer_object_instagram_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: true,
        grabCursor: true,
        spaceBetween: 16,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        centeredSlides: true,
        
        breakpoints: {
            0: {
                spaceBetween: 10,
                initialSlide: 1,
            },
            750: {
                spaceBetween: 16,
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
  }
});